import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { createCurrentHOC } from '@beef/redux';
import { createSelector } from '@reduxjs/toolkit';
import { getCurrentTariffValues } from "./valueGroupSelectors";

// @ts-expect-error fix later
var _createCurrentHOC = createCurrentHOC(getCurrentTariffValues, function (item) {
    return "".concat(item.group, "::").concat(item.kind);
  }),
  _createCurrentHOC2 = _slicedToArray(_createCurrentHOC, 2),
  __value = _createCurrentHOC2[0],
  withTariffValueMapper = _createCurrentHOC2[1];
export { __value, withTariffValueMapper };
var getTariffValues = __value;
var getTariffValueAmountRaw = function getTariffValueAmountRaw(state) {
  return getTariffValues(state).value;
};
var getTariffValueUnlimited = function getTariffValueUnlimited(state) {
  return getTariffValues(state).isUnlimited;
};
export var getTariffValueAmount = createSelector([getTariffValueAmountRaw, getTariffValueUnlimited], function (amount, isUnlimited) {
  return isUnlimited && '∞' || amount;
});
export var getTariffValueUnit = function getTariffValueUnit(state) {
  return getTariffValues(state).unit;
};